<section class="dashboard">
  <div class="dashboard-main">
    <header class="dashboard-header">
      <div>
        <h1>Business &amp; Estimates</h1>
      </div>
      <div class="header-actions">
        <a class="action-button" routerLink="/settings">← Back</a>
      </div>
    </header>

    <div class="panel-card">
      <div class="panel-header">
        <h2>Business Profile</h2>
      </div>
      <div class="panel-content">
        <div class="form-grid">
          <div class="form-field-group">
            <label>Company name</label>
            <input class="form-input" [(ngModel)]="form.companyName" />
          </div>
          <div class="form-field-group">
            <label>Contact email</label>
            <input class="form-input" type="email" [(ngModel)]="form.contactEmail" />
          </div>
          <div class="form-field-group">
            <label>Contact phone</label>
            <input class="form-input" type="tel" [(ngModel)]="form.contactPhone" />
          </div>
          <div class="form-field-group">
            <label>Address</label>
            <input class="form-input" [(ngModel)]="form.address" />
          </div>
          <div class="form-field-group">
            <label>Sales &amp; design hours</label>
            <input class="form-input" [(ngModel)]="form.salesHours" />
          </div>
          <div class="form-field-group">
            <label>Service hours</label>
            <input class="form-input" [(ngModel)]="form.serviceHours" />
          </div>
          <div class="form-field-group">
            <label>Commercial hours</label>
            <input class="form-input" [(ngModel)]="form.commercialHours" />
          </div>
          <div class="form-field-group">
            <label>Commercial contact label</label>
            <input class="form-input" [(ngModel)]="form.commercialContact" />
          </div>
          <div class="form-field-group">
            <label>Timezone</label>
            <select class="form-select" [(ngModel)]="form.timezone">
              <option value="America/Chicago">Central</option>
              <option value="America/Los_Angeles">Pacific</option>
              <option value="America/New_York">Eastern</option>
              <option value="America/Denver">Mountain</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="panel-card">
      <div class="panel-header">
        <h2>Estimate Defaults</h2>
      </div>
      <div class="panel-content">
        <div class="form-grid">
          <div class="form-field-group">
            <label>Default rate (per blind)</label>
            <input class="form-input" type="number" [(ngModel)]="form.defaultRate" />
          </div>
          <div class="form-field-group">
            <label>Default discount</label>
            <input class="form-input" type="number" [(ngModel)]="form.defaultDiscount" />
          </div>
          <div class="form-field-group">
            <label>Deposit percent</label>
            <input class="form-input" type="number" [(ngModel)]="form.depositPercent" />
          </div>
          <div class="form-field-group">
            <label>Warranty (months)</label>
            <input class="form-input" type="number" [(ngModel)]="form.warrantyMonths" />
          </div>
        </div>
      </div>
    </div>

    <div class="panel-card">
      <div class="panel-header">
        <h2>Customer Site Banner</h2>
      </div>
      <div class="panel-content">
        <div class="checkbox-group">
          <input type="checkbox" [(ngModel)]="form.constructionBannerEnabled" id="construction-banner" />
          <label for="construction-banner">Show the "under construction" banner on the customer site</label>
        </div>
        <div class="form-field-group">
          <label>Banner text</label>
          <textarea class="form-input term-textarea" rows="3" [(ngModel)]="form.constructionBannerText"></textarea>
        </div>
      </div>
    </div>

    <div class="panel-card">
      <div class="panel-header">
        <h2>Measurements &amp; Operations</h2>
      </div>
      <div class="panel-content">
        <div class="form-grid">
          <div class="form-field-group">
            <label>Measurement unit</label>
            <select class="form-select" [(ngModel)]="form.measurementUnit">
              <option value="in">Inches</option>
              <option value="cm">Centimeters</option>
            </select>
          </div>
          <div class="form-field-group">
            <label>Remotes per room</label>
            <input class="form-input" type="number" [(ngModel)]="form.remotePerRoom" />
          </div>
          <div class="form-field-group">
            <label>Blinds per remote</label>
            <input class="form-input" type="number" [(ngModel)]="form.remoteControls" />
          </div>
        </div>
        <div class="form-grid">
          <div class="checkbox-group">
            <input type="checkbox" [(ngModel)]="form.autoCloneModel" id="auto-clone" />
            <label for="auto-clone">Auto-clone rooms/windows for matching models</label>
          </div>
          <div class="checkbox-group">
            <input type="checkbox" [(ngModel)]="form.warnMeasurementVariance" id="warn-measure" />
            <label for="warn-measure">Warn on measurements &gt; 2 inches apart</label>
          </div>
          <div class="checkbox-group">
            <input type="checkbox" [(ngModel)]="form.includeInstallation" id="include-install" />
            <label for="include-install">Installation included by default</label>
          </div>
          <div class="checkbox-group">
            <input type="checkbox" [(ngModel)]="form.includeSolarPanels" id="include-solar" />
            <label for="include-solar">Include required solar panels</label>
          </div>
        </div>
        <button class="action-button primary" (click)="save()" [disabled]="saving()">
          {{ saving() ? "Saving..." : "Save settings" }}
        </button>
      </div>
    </div>

    @if (message(); as message) {
      <div class="status-message">{{ message }}</div>
    }
  </div>
</section>
